// @ts-check
import React, { useCallback } from 'react';
import { useMutation } from 'react-query';
import { usePortalConfig } from 'shared/context/PortalConfig';
import api from 'utils/api';
import PromiseButton from 'shared/components/PromiseButton';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import { getErrorMessage } from 'utils/reduxFormWrapper';

/** @typedef {{
  appointmentId: string;
  onSuccess(): void;
  onFailure?(message: string): void;
  className?: string;
}} UncompleteAppointmentButtonProps */

/** @type { React.FC<UncompleteAppointmentButtonProps> } */
export const UncompleteAppointmentButton = (props) => {
  const {
    appointmentId,
    onSuccess,
    className = 'btn btn-mini btn-warning',
    children,
  } = props;

  const { apiPrefix } = usePortalConfig();

  const mutation = useMutation((/** @type { string } */ appointmentId) =>
    api
      .put(`${apiPrefix}/appointments/${appointmentId}/uncomplete`)
      .then((resp) => resp.data)
  );

  const onSubmit = useCallback(() => {
    return mutation.mutateAsync(appointmentId).then(
      (_data) => {
        FlashMessageActions.flashSuccess({
          message: 'Appointment unmarked as completed',
        });
        return onSuccess();
      },
      (err) => {
        console.error(err);
        FlashMessageActions.flashInfo({
          message: getErrorMessage(err),
        });
      }
    );
  }, [appointmentId, onSuccess]);

  return (
    <PromiseButton
      className={`_UncompleteAppointmentButton ${className || ''}`}
      onClick={onSubmit}
    >
      {children}
    </PromiseButton>
  );
};
